var _a;
import * as _ from 'lodash';
import * as keyboardKey from 'keyboard-key';
import keyboardHandlerFilter from './keyboardHandlerFilter';
var rtlKeyMap = (_a = {},
    _a[keyboardKey.ArrowRight] = keyboardKey.ArrowLeft,
    _a[keyboardKey.ArrowLeft] = keyboardKey.ArrowRight,
    _a);
/**
 * Assigns onKeyDown handler to the Component's part element, based on Component's actions
 * and keys mappings defined in Accessibility behavior
 * @param {AccessibilityActionHandlers} componentActionHandlers Actions handlers defined in a component.
 * @param {KeyActions} behaviorKeyActions Mappings of actions and keys defined in Accessibility behavior.
 * @param {State & PropsWithVarsAndStyles} props The props which are used to invoke onKeyDown handler passed from top.
 * @param {boolean} isRtlEnabled Indicates if Left and Right arrow keys should be swapped in RTL mode.
 */
var getKeyDownHandlers = function (componentActionHandlers, behaviorKeyActions, props, isRtlEnabled) {
    var keyHandlers = {};
    if (!componentActionHandlers || !behaviorKeyActions)
        return keyHandlers;
    var _loop_1 = function (componentPart) {
        var componentPartKeyAction = behaviorKeyActions[componentPart];
        var handledActions = _.intersection(_.keys(componentPartKeyAction), _.keys(componentActionHandlers));
        if (!handledActions.length)
            return "continue";
        keyHandlers[componentPart] = {
            onKeyDown: function (event) {
                handledActions.forEach(function (actionName) {
                    var keyCombinations = componentPartKeyAction[actionName].keyCombinations;
                    if (isRtlEnabled) {
                        keyCombinations = keyCombinations.map(function (keyCombination) {
                            var keyToRtlKey = rtlKeyMap[keyCombination.keyCode];
                            if (keyToRtlKey) {
                                keyCombination.keyCode = keyToRtlKey;
                            }
                            return keyCombination;
                        });
                    }
                    var eventHandler = keyboardHandlerFilter(componentActionHandlers[actionName], keyCombinations);
                    eventHandler && eventHandler(event);
                });
                _.invoke(props, 'onKeyDown', event, props);
            },
        };
    };
    for (var componentPart in behaviorKeyActions) {
        _loop_1(componentPart);
    }
    return keyHandlers;
};
export default getKeyDownHandlers;
